$eve_app_page_components_segmented $eve_app_page_sb_page
	title \Segmented Control
	Head null
	body /
		<= Segmented_catalog $eve_app_page_sb_catalog
			param \segmented
			spreads *
				basic <= Basic_page $eve_app_page_sb_page
					title \Basic
					body /
						<= Basic_playground $eve_app_page_sb_playground
							component_name \Live_segmented
							default_source \
								\Live_segmented $eve_segmented
								\	value? \home
								\	options *
								\		home \home
								\		profile \profile
								\		settings \settings
								\		about \about
								\
